'use client';

import React from 'react';
import {
  Clock,
  Sparkles,
  Instagram,
  Compass,
  ArrowRight,
  BellRing,
  CheckCircle2
} from 'lucide-react';
import { Link } from 'react-router-dom';

const ComingSoonDaftar = () => {
  const benefits = [
    'Pengalaman organisasi level kabupaten bersama pengurus OSIS se-DIY',
    'Pelatihan kepemimpinan, public speaking, & manajemen program kerja',
    'Relasi luas lintas SMA, SMK, dan MA di Kulon Progo',
    'Sertifikat apresiasi & naungan resmi Balai Dikmen DIY'
  ];

  return (
    <div
      className="min-h-screen bg-slate-950 bg-fixed bg-cover bg-center relative font-sans selection:bg-indigo-500 selection:text-white"
      style={{ backgroundImage: `url('/bg.jpg')` }}
    >
      {/* Dark Overlay with Blur */}
      <div className="absolute inset-0 bg-slate-950/85 backdrop-blur-sm z-0"></div>

      <main className="relative z-10 flex-grow py-24 md:py-32 text-slate-200">
        <div className="container mx-auto px-4 md:px-6">

          <div className="flex flex-col lg:flex-row items-center gap-12 xl:gap-20">

            {/* --- KOLOM KIRI: INFO & PERSIAPAN --- */}
            <div className="lg:w-1/2 space-y-8 text-center lg:text-left">
              
              {/* Header Section */}
              <div className="space-y-6">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-xs font-bold tracking-widest uppercase shadow-[0_0_20px_rgba(99,102,241,0.2)]">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
                  </span>
                  Open Recruitment 2027
                </div>

                <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight tracking-tight">
                  Mari Berkarya <br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-purple-400 to-cyan-400">
                    Bersama FKPO
                  </span>
                </h1>

                <p className="text-base md:text-lg text-slate-300/90 leading-relaxed max-w-xl mx-auto lg:mx-0">
                  Kepengurusan periode aktif baru saja dilantik. Seleksi & pendaftaran pengurus FKPO Kulon Progo periode 2027 akan segera dibuka tahun depan.
                </p>
              </div>

              {/* What you will get */}
              <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-6 backdrop-blur-md space-y-3 text-left">
                <h4 className="text-xs font-bold uppercase tracking-wider text-indigo-400 flex items-center gap-2">
                  <Sparkles className="w-4 h-4" />
                  Apa Yang Kamu Dapatkan Nanti?
                </h4>
                <ul className="space-y-2.5">
                  {benefits.map((benefit, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-xs sm:text-sm text-slate-300">
                      <CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Navigation Back */}
              <div className="flex flex-wrap gap-4 justify-center lg:justify-start pt-2">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-slate-900 hover:bg-slate-800 text-slate-300 hover:text-white rounded-xl border border-slate-800 text-sm font-semibold transition-all"
                >
                  <Compass className="w-4 h-4 text-indigo-400" />
                  <span>Jelajahi Beranda</span>
                </Link>
                <Link
                  to="/kegiatan"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-slate-900 hover:bg-slate-800 text-slate-300 hover:text-white rounded-xl border border-slate-800 text-sm font-semibold transition-all"
                >
                  <span>Lihat Kegiatan Kami</span>
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>

            </div>

            {/* --- KOLOM KANAN: COMING SOON CARD --- */}
            <div className="lg:w-1/2 w-full flex flex-col gap-6 relative">

              {/* === COMING SOON CARD === */}
              <div className="relative group w-full">
                <div className="absolute -inset-1 bg-gradient-to-r from-pink-500 via-indigo-500 to-cyan-500 rounded-3xl blur opacity-30 group-hover:opacity-50 transition duration-500"></div>
                <div className="relative bg-slate-900/90 backdrop-blur-2xl border border-white/10 p-8 sm:p-10 rounded-2xl shadow-2xl">

                  <div className="flex items-center justify-between mb-8 border-b border-white/10 pb-4">
                    <div className="flex items-center gap-3">
                      <div className="p-2.5 bg-indigo-500/20 rounded-xl text-indigo-400">
                        <Clock size={22} className="animate-spin-slow" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-white tracking-wide">
                          Status Pendaftaran
                        </h3>
                        <p className="text-xs text-slate-400">Periode Seleksi 2027</p>
                      </div>
                    </div>
                    <span className="px-3 py-1 bg-amber-500/10 border border-amber-500/30 text-amber-400 text-xs font-bold rounded-full">
                      Belum Dibuka
                    </span>
                  </div>

                  <div className="text-center py-6 space-y-6">
                    <div className="w-20 h-20 rounded-full bg-indigo-500/10 border border-indigo-500/20 flex items-center justify-center mx-auto text-indigo-400">
                      <BellRing className="w-10 h-10 animate-bounce" />
                    </div>

                    <div className="space-y-2">
                      <h4 className="text-2xl font-bold text-white">Segera Hadir</h4>
                      <p className="text-slate-300/80 text-sm leading-relaxed max-w-sm mx-auto">
                        Pengumuman timeline berkas dan pembukaan pendaftaran resmi akan dipublikasikan secara langsung melalui akun Instagram kami.
                      </p>
                    </div>

                    <div className="pt-4 border-t border-slate-800">
                      <a
                        href="https://www.instagram.com/fkpo_kulonprogo/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-2.5 w-full py-3.5 px-6 rounded-xl bg-gradient-to-r from-pink-600 to-indigo-600 hover:from-pink-500 hover:to-indigo-500 text-white font-semibold text-sm transition-all shadow-lg shadow-pink-600/20 hover:shadow-pink-600/40 hover:scale-[1.01]"
                      >
                        <Instagram className="w-4 h-4" />
                        <span>Ikuti Instagram Resmi @fkpo_kulonprogo</span>
                      </a>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ComingSoonDaftar;
